// extracted by mini-css-extract-plugin
module.exports = {"checkLabel":"CheckLabel_checkLabel__1di0s","borderTop":"CheckLabel_borderTop__1VDoU","borderBottom":"CheckLabel_borderBottom__2Ssf9","disabled":"CheckLabel_disabled__2ayKq"};